import * as OrderDetailService from "../../../common/ShareFun/OrderDetailService";
import setContent from "../setContent";
import ReferencData from "../../../common/ShareFun/ReferencData";
import { getPetDetails } from "../../../common/Models/PetDetailsModel/PetDetailsModel";
import { batch } from 'react-redux';

export const UPDATE_PETLIST = 'UPDATE_PETLIST';
export const SET_GENDER_TYPES = 'SET_GENDER_TYPES';
export const SET_PET_SIZES = 'SET_PET_SIZES';
export const SET_PET_TYPES = 'SET_PET_TYPES';
export const PETLIST_FETCHED = 'PETLIST_FETCHED';
export const UPDATE_PET_DETAILS_VALIDATION = 'UPDATE_PET_DETAILS_VALIDATION';

// set if pet validation is required
export function updatePetDetailsValidation(validation) {
    return setContent(UPDATE_PET_DETAILS_VALIDATION, validation);
}

export function updatePetList(petDetailsList) {
    return {
        type: UPDATE_PETLIST,
        petList: petDetailsList
    }
}

// fetch all the data for pet page
export function fetchPetData(relocationPet) {
    let forceUpdate = true;
    const { petList } = relocationPet;
    if (petList && petList.length > 0) {
        if (parseInt(sessionStorage.getItem('RelocationPlanId')) === parseInt(petList[0].RelocationPlanID)) {
            forceUpdate = false;
        }
    }
    return dispatch => {
        batch(() => {
            dispatch(retrieveGenderTypes(relocationPet));
            dispatch(retrievePetSizes(relocationPet));
            dispatch(retrievePetTypes(relocationPet));
            dispatch(retrieveRelocationPlanPetDetails(relocationPet, forceUpdate))
        })
    }
}

// retrieveGenderTypes
export function retrieveGenderTypes(relocationPet) {
    return async dispatch => {
        if (relocationPet.genderTypes.length === 0) {
            return ReferencData.referenceDataService(null, 'RetrieveGenderTypes')
                .then(res => {
                    dispatch(setContent(SET_GENDER_TYPES, res));
                    return res;
                })
        }
    }
}

// retrievePetSizes
export function retrievePetSizes(relocationPet) {
    return async dispatch => {
        if (relocationPet.petSizes.length === 0) {
            return ReferencData.referenceDataService(null, 'RetrievePetSizes')
                .then(res => {
                    dispatch(setContent(SET_PET_SIZES, res));
                    return res;
                })
        }
    }
}

// retrievePetTypes
export function retrievePetTypes(relocationPet) {
    return async dispatch => {
        if (relocationPet.petTypes.length === 0) {
            return ReferencData.referenceDataService(null, 'RetrievePetTypes')
                .then(res => {
                    dispatch(setContent(SET_PET_TYPES, res));
                    return res;
                })
        }
    }
}

// 1st argument check if pet details is fetched
// 2nd argument is for update
export function retrieveRelocationPlanPetDetails(relocationPet, forceUpdate) {
    return dispatch => {
        if (relocationPet.petList.length === 0 || forceUpdate) {
            const relocationPlanId = sessionStorage.getItem('RelocationPlanId');
            const petDetails = [];
            const id = { Id: relocationPlanId };
            return OrderDetailService.retrieveOrderDetailsService('RetrieveRelocationPlanPetDetails', id)
                .then(res => {
                    res.RelocationPlanPets.forEach(pet => {
                        petDetails.push(getPetDetails(pet));
                    });
                    dispatch(updatePetList(petDetails));
                    // need to add a checker to check if pet detail is fetched
                    dispatch(setContent(PETLIST_FETCHED, true));
                    return res;
                })
        }
    }
}